/**
 * Paths that are guest-only (login, signup, reset password).
 * Must not be used as redirect targets after login to avoid redirect loops.
 */
export const GUEST_ONLY_PATHS: readonly string[] = [
  '/login',
  '/signup',
  '/send-reset-mail',
  '/reset-password',
];

/** Location-like object (pathname + search) used for redirect target */
export interface LocationLike {
  pathname: string;
  search?: string;
}

/**
 * Returns the path to redirect to after successful login.
 *
 * @param from - Location saved when redirecting to login (from state)
 * @param dashboardPath - Default path (dashboard) when from is missing or invalid
 * @returns Target path to navigate to (pathname + search) or dashboardPath
 */
export function getRedirectPathAfterLogin(
  from: LocationLike | undefined,
  dashboardPath: string,
): string {
  if (!from?.pathname || GUEST_ONLY_PATHS.includes(from.pathname)) {
    return dashboardPath;
  }
  return `${from.pathname}${from.search ?? ''}`;
}
